import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-envios-form',
  templateUrl: './envios-form.component.html',
  styleUrls: ['./envios-form.component.scss']
})
export class EnviosFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
